import { gql } from "@apollo/client";

export interface IConnectProfileViaLinkVars {
  token: string;
}

export interface IConnectProfileViaLink {
  connected: boolean;
  profileId?: string;
}

export const CONNECT_PROFILE_VIA_LINK = gql`
  mutation connectProfileViaLink($token: String!) {
    connectProfileViaLink(token: $token) {
      connected
      profileId
    }
  }
`;
